export default __webpack_public_path__ + "static/media/portafolio.985327ba.PNG";